import React from 'react'
import './index.scss'

interface DynamicTextProps {
  bg?: string
  type?: string
}

const LoaderCogx: React.FC<DynamicTextProps> = ({
  bg = '',
  type = 'loader-custom--absolute',
}) => {
  return (
    <div
      className={`loader-custom ${bg} ${type} d-flex justify-content-center align-items-center`}
    >
      {type === 'loader-custom--absolute' ? (
        <div className="blink">
          <img
            alt="logo Coggx"
            src="/cogx.svg"
            className="logo"
            draggable="false"
          />
        </div>
      ) : (
        <div className="loader" />
      )}
    </div>
  )
}

export default LoaderCogx
